import React, {Component} from "react";
import CommToolContext from "../common/comm_tool_context";
import Review from "../startproj/Review";
import {getPdfReport, updateProject} from "../../api";
import {withRouter} from "react-router-dom";
import Button from "../../components/Button";
import {Col, Grid, Row} from "react-flexbox-grid";
import ShowChecklistProjectConfirmDialog from "../startproj/ChecklistProjectNAConfirmDialog";
import {spinnerOff, spinnerOn} from "../../components/Spinner";
import {isCreatorOrAdministrator, isViewOnly} from "../../utils/UserInfo";
import UndoPopUp from "../../components/UndoPopUp"
import PdfReport from "../common/pdf"
import Errors from "../../components/Errors";

class ReleaseReview extends Component {
    constructor(props) {
        super(props);
        this.handleEditProject = this.handleEditProject.bind(this);
        this.handleActiveProject = this.handleActiveProject.bind(this);
        this.handleEditTeam = this.handleEditTeam.bind(this);
        this.checklistNAProject = this.checklistNAProject.bind(this);
        this.handleViewAsset = this.handleViewAsset.bind(this);
    }

    state = {};

    handleEditProject() {
        this.props.history.push(`/release/${this.props.project.id}/details`);
    }
    handleEditTeam(){
        this.props.history.push(`/release/${this.props.project.id}/team`);
    }
    handleViewAsset() {
        this.props.history.push(`/release/${this.props.project.id}/assetsummary`);
    }
    closeErrorBox(){
        const error = null;
        this.setState({error});
    }

    async saveAndRedirect(projStatus) {
        const {
            setStep,
            setActiveProject,
            setLaunchDashboard,
            setActiveDashboardTab,
            setRefreshNotifications
        } = this.props.context;
        const newAttributes = {
            workOrder: this.state.workOrder || this.props.project.workOrder,
            commissionStartDate:
                this.state.commisionStartDate || this.props.project.commisionStartDate,
            projectStatus: projStatus
        };


        const updatedProject = {
            ...this.props.project,
            ...newAttributes
        };
        spinnerOn();
        await updateProject(updatedProject);
        spinnerOff();
        setActiveProject(updatedProject);
        setRefreshNotifications(true);
        setActiveDashboardTab(projStatus);
        setStep(9);
        setLaunchDashboard(true);

    }
    /**
     *Set Active and set to "Active Tab".
     */
    async handleActiveProject() {
        const {
            setActiveProject
        } = this.props.context;
        const newAttributes = {
            projectStatus: "A"
        };

        const updatedProject = {
            ...this.props.project,
            ...newAttributes
        };
        await updateProject(updatedProject);
        setActiveProject(updatedProject);
        this.props.history.push(`/dashboard/active`);
    }
    /**
     *
     * Set project to Checklist NA and go back to the Active Tab
     */

    async checklistNAProject() {
        this.setState({error: null});
        this.checkListNAProjectConfirm();
    }

    checkListNAProjectConfirm = () => {
        ShowChecklistProjectConfirmDialog(this.props.project, this.props.history, this.props.context);
    }


    render() {
        const project = this.props.project;
        return (
            <Grid fluid>
                <Errors error={this.state.error}
                        onCloseBox={this.closeErrorBox} />
                <div className="row">
                    <Review
                        project={this.props.project}
                        onEditProject={this.handleEditProject}
                        onEditTeam={this.handleEditTeam}
                        onViewAsset={this.handleViewAsset}
                        teamMembers={this.props.teamMembers}
                        />
                </div>

                <div className="container-fluid">
                  <Row className="dtls-button">
                    <Col xs={12} style={{marginLeft: '-15px'}}>
                    { isCreatorOrAdministrator() &&
                        <Button
                            onClickHandler={this.handleActiveProject.bind(this)}
                        >
                            Set Active
                        </Button>
                    }
                    { isCreatorOrAdministrator() &&
                        <Button
                            onClickHandler={this.checklistNAProject.bind(this)}
                        >
                            Checklist N/A
                        </Button>
                    }
                    { isCreatorOrAdministrator() &&
                        <UndoPopUp
                            project={project}
                            history={this.props.history}
                            context={this.props.context}
                            undoStatus={"Undo Release Project"}/>
                    }
                      <PdfReport project={this.props.project}/>

                    </Col>
                </Row>
                </div>
            </Grid>
        );
    }
}

ReleaseReview.contextType = CommToolContext;
export default withRouter(ReleaseReview);

